var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m2.68768912 14.666666-.02102-6.66668453h-2.66666912v-2.66666382h2.66666912v-1.66665614c0-2.47426427 1.5322095-3.66666151 3.73941877-3.66666151 1.05727965 0 1.96595936.07871322 2.23076927.11389974v2.58574401l-1.5308195.0007c-1.2004096 0-1.43282953.57040867-1.43282953 1.40745674v1.22551716h3.49345885l-1.33333956 2.66666382h-2.16011929v6.66668453z","fill":"#fff","transform":"translate(4.267659 .666667)"}));
}

FacebookIcon.defaultProps = {"height":"16","viewBox":"0 0 17 16","width":"17"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
